import {useDiscipline} from "@/hooks/useDiscipline";
import type {TPunishmentType} from "@/store/types";
import {memo, type FC} from "react";
import {useTranslation} from "react-i18next";

const RESTRICTIONS: Record<TPunishmentType, string> = {
  PERMANENT_BAN: "restriction_ban",
  PROBATION: "restriction_probation",
  TIMED_BAN: "restriction_timed_ban",
  UN_VERIFIED_INSTAGRAM: "restriction_unverify",
  UN_VERIFIED_TIKTOK: "restriction_unverify",
  UN_VERIFIED_UGC: "restriction_unverify",
};

const RestrictionSection: FC = () => {
  const {disciplineTabInPunishmentType} = useDiscipline();
  const {t} = useTranslation("influencer_discipline");

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs">{t("restrictions")}</span>
      <div className="grid grid-cols-2 items-center justify-center gap-2">
        <span className="border-danger-medium-red flex h-full items-center rounded-sm border p-3">
          {t(RESTRICTIONS[disciplineTabInPunishmentType])}
        </span>
        <span className="border-danger-medium-red flex h-full items-center rounded-sm border p-3">
          {t(
            `restriction_influencer_sees_${disciplineTabInPunishmentType === "PROBATION" || disciplineTabInPunishmentType === "TIMED_BAN" ? "instantly" : "later"}`,
          )}
        </span>
      </div>
    </div>
  );
};

export default memo(RestrictionSection);
